// extracted by mini-css-extract-plugin
module.exports = {"root":"BlogItem_root__bGc-H","thumbnail":"BlogItem_thumbnail__2oOog","meta":"BlogItem_meta__1ydKO"};